<template>
	<div class="products-intro-table">
		<!-- PC端表格布局 -->
		<div class="pc-table">
			<el-table :data="tableData" border style="width: 100%" @row-click="clickRow">
				<el-table-column prop="qrCode" min-width="30%">
					<template slot-scope="scope">
						<img class="w-100" :src="scope.row.thumbnail" >
					</template>
				</el-table-column>
				<el-table-column prop="PTName" label="型号"  min-width="10%"> </el-table-column>
				<el-table-column label="资源" min-width="30%">
					<template slot-scope="scope">
						<span v-html="scope.row.Resource"></span>
					</template>
				</el-table-column>
				<el-table-column label="简介" min-width="30%">
					<template slot-scope="scope">
						<span v-html="scope.row.Intro"></span>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 移动端卡片布局 -->
		<div class="mobile-card-list">
			<div class="mobile-card" v-for="(item, index) in tableData" :key="index" @click="clickRow(item)">
				<div class="card-img">
					<img :src="item.thumbnail" alt="">
				</div>
				<div class="card-info">
					<div class="card-model">
						<span class="card-label">型号</span>
						<span class="card-value">{{ item.PTName }}</span>
					</div>
					<div class="card-item">
						<span class="card-label">资源</span>
						<span class="card-value" v-html="item.Resource"></span>
					</div>
					<div class="card-item">
						<span class="card-label">简介</span>
						<span class="card-value" v-html="item.Intro"></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>	
	export default{
		props: {
			tableDataKey:{
				type: String,
				default:'0'
			},
			tableData: []
		},
		methods:{
			clickRow (row) {
			    this.$router.push("/product-detail/" +row.id);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.products-intro-table {
		width: 100%;
	}

	/* PC端显示表格，移动端隐藏 */
	.pc-table {
		display: block;
	}
	.mobile-card-list {
		display: none;
	}

	/* 移动端适配：屏幕宽度小于768px */
	@media (max-width: 768px) {
		/* 移动端隐藏表格，显示卡片 */
		.pc-table {
			display: none;
		}
		.mobile-card-list {
			display: block;
			padding: 10px;
			box-sizing: border-box;
		}

		/* 卡片样式 */
		.mobile-card {
			background: #fff;
			border-radius: 8px;
			margin-bottom: 12px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
			overflow: hidden;
			cursor: pointer;
			transition: box-shadow 0.2s;

			&:active {
				box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
			}

			.card-img {
				width: 100%;
				padding: 15px;
				box-sizing: border-box;
				background: #fafafa;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					max-width: 100%;
					max-height: 160px;
					object-fit: contain;
				}
			}

			.card-info {
				padding: 12px 15px;

				.card-model {
					display: flex;
					padding-bottom: 8px;
					margin-bottom: 8px;
					border-bottom: 1px solid #f0f0f0;
					font-size: 15px;
					font-weight: 600;
					color: #303133;

					.card-label {
						flex-shrink: 0;
						width: 50px;
						color: #909399;
						font-weight: 500;
						font-size: 13px;
						line-height: 22px;
					}

					.card-value {
						flex: 1;
					}
				}

				.card-item {
					display: flex;
					padding: 5px 0;
					font-size: 13px;
					line-height: 1.6;

					.card-label {
						flex-shrink: 0;
						width: 50px;
						color: #909399;
						font-weight: 500;
					}

					.card-value {
						flex: 1;
						color: #606266;
						word-break: break-all;
					}
				}
			}
		}
	}

	/* 小屏手机适配：屏幕宽度小于480px */
	@media (max-width: 480px) {
		.mobile-card-list {
			padding: 8px;
		}

		.mobile-card {
			margin-bottom: 10px;

			.card-img {
				padding: 12px;

				img {
					max-height: 140px;
				}
			}

			.card-info {
				padding: 10px 12px;

				.card-model {
					font-size: 14px;

					.card-label {
						font-size: 12px;
						width: 45px;
					}
				}

				.card-item {
					font-size: 12px;

					.card-label {
						width: 45px;
					}
				}
			}
		}
	}
</style>